module.exports = __webpack_public_path__ + "img/IMGP8622.13d6285a.jpg";